import { render } from "./nav-bar.vue?vue&type=template&id=5405c55a&scoped=true&ts=true"
import script from "./nav-bar.vue?vue&type=script&lang=ts"
export * from "./nav-bar.vue?vue&type=script&lang=ts"

import "./nav-bar.vue?vue&type=style&index=0&id=5405c55a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5405c55a"]])

export default __exports__